import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ServerResponse } from '../models/types';
import { GetLocalForageConFigService } from "./getLocalForage.service";
import { async } from 'q';
import * as localForage from 'localforage';
import { KMChietKhauTheVip, SuKienGia, KMHangHoaChietKhau } from "../models/sukiengia.model";
import { Store } from "@ngrx/store";
import { JWTService } from "./JWTService";

@Injectable()
export class SuKienGiaService {
  dsSuKienGia: Array<SuKienGia> = new Array<SuKienGia>();
  dsKMVip: Array<KMChietKhauTheVip> = new Array<KMChietKhauTheVip>();
  dsKMHH: Array<KMHangHoaChietKhau> = new Array<KMHangHoaChietKhau>();
  url: any
  constructor(
    private http: HttpClient,
    private storeSKG: Store<SuKienGia>,
    private storeKMVip: Store<KMChietKhauTheVip>,
    private storeKMHH: Store<KMHangHoaChietKhau>,
    private jwtService: JWTService,
    private getlocalconfig: GetLocalForageConFigService,
    @Inject('BASE_URL') baseUrl: string,
  ) {
    this.url = baseUrl;
  }


  async getSuKienGia(value: string) {
    return this.http.post(this.url + 'api/SuKienGia/getSuKienGia', { STORE: value })
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          this.dsSuKienGia = result[0].data;
          console.log(result[0].data);
          const str = this.jwtService.enCryptData(this.dsSuKienGia);
          this.storeSKG.dispatch({ type: 'INIT_SuKienGia', skg: this.dsSuKienGia });
          this.getlocalconfig.getConfigLocalForage()
            .then(async res => {
              await localForage.setItem('_dsSKG', str);
            });
          console.log('getSuKienGia');
          return Promise.resolve(this.dsSuKienGia);
        } else {
          //throw new Error(result[0].message)
          return Promise.reject(null);
        }
      });
  }

  async getKMVip_63(value: string) {
    return this.http.post(this.url + 'api/SuKienGia/getKMTOPOS', { STORE: value })
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          this.dsKMVip = result[0].data;
          console.log(result[0].data);
          const str = this.jwtService.enCryptData(this.dsKMVip);
          this.storeKMVip.dispatch({ type: 'INIT_KMVip', kmvip: this.dsKMVip });
          this.getlocalconfig.getConfigLocalForage()
            .then(async res => {
              await localForage.setItem('_dsKMVip', str);
            });
          console.log('get KM VIP');
          return Promise.resolve(this.dsKMVip);
        } else {
          //throw new Error(result[0].message)
          return Promise.reject(null);
        }
      });
  }

  async getKMHH_63(value: string) {
    return this.http.post(this.url + 'api/SuKienGia/getKMTOPOS_CKHH', { STORE: value })
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          this.dsKMHH = result[0].data;
          console.log(result[0].data);
          const str = this.jwtService.enCryptData(this.dsKMHH);
          this.storeKMHH.dispatch({ type: 'INIT_KMHH', kmhh: this.dsKMHH });
          this.getlocalconfig.getConfigLocalForage()
            .then(async res => {
              await localForage.setItem('_dsKMHH', str);
            });
          console.log('get KM CKHH');
          return Promise.resolve(this.dsKMHH);
        } else {
          //throw new Error(result[0].message)
          return Promise.reject(null);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sukiengia.service.ts